// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc40ccf0","453":"e7c8283a","455":"87a97f31","977":"ea28ba75"}[chunkId] + ".chunk.js";
};